module.exports = __webpack_public_path__ + "assets/img/d835b8b1290d4179133751c7d7a5032c.svg";